var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CE9AD491-51E1-4B27-82BE-4EFE720374F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666667,6 L10,6 L10,2 L6,2 L6,6 L3.33333333,6 L8,10.6666667 L12.6666667,6 Z M3.33333333,12 L3.33333333,13.3333333 L12.6666667,13.3333333 L12.6666667,12 L3.33333333,12 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0440\\u043E\\u0442\\u043E\\u0442\\u0438\\u043F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0440\\u0430\\u043A\\u0442-2-\\u0444\\u0438\\u043D-\\u0443\\u0441\\u043B\\u043E\\u0432\\u0438\\u044F-\\u0440\\u0430\\u0441\\u043A\\u0440\\u044B\\u0442\\u0438\\u0435-Copy-6",
    transform: "translate(-103.000000, -185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(85.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/file_download",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_file_download_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600-copy-2",
    mask: "url(#mask-2)",
    fill: "#F5F5FC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldWhiteArrow);
export default __webpack_public_path__ + "static/media/bold-white-arrow.da081b101873a36ca231f45808f97c1d.svg";
export { ForwardRef as ReactComponent };